function serializableClone(object) {
  const output = {};
  // We explicitly want to copy the inherited properties
  // eslint-disable-next-line guard-for-in
  for (const key in object) {
    output[key] = object[key];
  }
  return output;
}

export { serializableClone };
